// social icons - White
export const Instagram = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/social/white/Instagram.png"
export const Whatsapp = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/social/white/Whatsapp.png"
export const Facebook = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/social/white/Facebook.png"
export const Youtube = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/social/white/Youtube.png"
export const Linkedin = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/social/white/LinkedIn.png"
export const Mail = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/social/white/Mail.png"
export const GooglePlay = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/MVP/UserPage/PlayStore.png";
export const AppStore = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/MVP/UserPage/AppStore.png";

// EvolvFit Logo - White
export const Logo = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/brand/EvolvLogo.png"

// Images
// Mobile Image in Hero Section
export const HeroMobile = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/landing/AppPicture.png"

// Services Section
export const Dumbell = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/landing/Workout.png"
export const Nutrient = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/landing/Nutrition.png"

// Transformation Section
export const QuoteOpen = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/landing/icons/QuoteOpen.png"
export const QuoteClose = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/landing/icons/QuoteClose.png"

// Transformations
export const SatyamBefore = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/landing/transformations/before/SatyamBefore.jpeg"
export const SatyamAfter = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/landing/transformations/after/SatyamAfter.jpeg"
export const TanujBefore = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/landing/transformations/before/TanujBefore.jpeg"
export const TanujAfter = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/landing/transformations/after/TanujAfter.jpeg"
export const SrijanBefore = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/landing/transformations/before/SrijanBefore.jpeg"
export const SrijanAfter = "https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/landing/transformations/after/SrijanAfter.jpeg"

// Contact Section
export const Calender3d = 'https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/landing/icons/calendar3d.png'
export const Whatsapp3d = 'https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-assets/landing/icons/whatsapp3d.png'

//icon
export const CloseButtonIcon = 'https://gcp-old-data.s3.ap-south-1.amazonaws.com/evolv-store/icons/common/close.svg'
